/*
 * PrimeVue heeft in ToastMessage.vue wél pauzeer-logica zitten (onMouseEnter/onMouseLeave),
 * maar die is in 4.3.3 onbereikbaar: hij zit achter `if (this.props?.onMouseEnter)` terwijl
 * ToastMessage helemaal geen `props`-prop kent (alleen `message`, `templates`, iconen, ...).
 * En zelfs als je er wél in komt, rekent hij met `Date().valueOf()` (string i.p.v. getal),
 * waardoor de resterende tijd NaN wordt en de toast direct sluit.
 *
 * Daarom regelen we het zelf: bij mouseenter stoppen we de timer en onthouden we hoeveel
 * tijd er nog over was, bij mouseleave starten we een nieuwe timer met die resttijd.
 * We hergebruiken hiervoor de interne timer-methodes van ToastMessage, zodat het sluiten
 * (transitie, close-event, opruimen) precies hetzelfde blijft werken als normaal.
 */
type ToastMessageInstance = {
  message?: { life?: number };
  /** tijdstip waarop de lopende timer is gestart; null zolang er gepauzeerd wordt */
  createdAt?: number | null;
  /** resterende levensduur in ms */
  lifeRemaining?: number | null;
  startTimeout: () => void;
  clearCloseTimeout: () => void;
};

/** Toasts zonder `life` (errors, indefinite) blijven sowieso staan; die hoeven we niet te pauzeren. */
const heeftLopendeTimer = (instance?: ToastMessageInstance) => Boolean(instance?.message?.life);

export const pauseToastLife = (instance: ToastMessageInstance) => {
  if (!heeftLopendeTimer(instance) || typeof instance.createdAt !== 'number') return;

  const verstreken = Date.now() - instance.createdAt;
  instance.lifeRemaining = Math.max(0, (instance.lifeRemaining ?? 0) - verstreken);
  instance.createdAt = null;
  instance.clearCloseTimeout();
};

export const resumeToastLife = (instance: ToastMessageInstance) => {
  if (!heeftLopendeTimer(instance) || typeof instance.createdAt === 'number') return;

  instance.startTimeout();
};
